"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixedActionBar = void 0;
exports.fixedActionBar = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    backgroundColor: 'rgba(255, 255, 255, 1) !important',
    padding: '20px 110px',
};
//# sourceMappingURL=FixedActionBar.styles.js.map